import { createContext } from "react";

const BuilderDragDropContext = createContext();

export default BuilderDragDropContext;
